import { Component, Input, NgZone, OnInit, ViewChild } from '@angular/core';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { ContactService } from 'src/app/services/contact.service';
import { CNConsultation } from 'src/app/models/cnconsultation';
import { MatTableDataSource } from '@angular/material/table';
import { PageEvent } from '@angular/material/paginator';
import * as moment from 'moment';

@ManageType('ContactTableComponent')
@Component({
  selector: 'app-contact-table',
  templateUrl: './contact-table.component.html',
  styleUrls: ['./contact-table.component.scss']
})
export class ContactTableComponent implements OnInit {

  displayedColumns: string[] = ['contact'];
  public contacts = new MatTableDataSource<CNConsultation>();
  @ViewChild('paginator', { static: true }) thePaginator;
  private myShowPaginator = true;

  @Input() pageSize = 5;

  constructor(public contactservice: ContactService, private ngZone: NgZone) { }

  ngOnInit(): void {
    this.contactservice.data.subscribe(data => {
      this.contacts.data = data;
    });
    this.contactservice.clear.subscribe(flag => {
      console.log('contact cleared');
      if (this.myShowPaginator && this.thePaginator) {
        this.thePaginator.pageIndex = 0;
      }
    });
  }

  @Input() set paginator(flag: boolean) {
    this.myShowPaginator = flag;
  }

  get paginator(): boolean {
    return this.myShowPaginator;
  }

  changePage(event: PageEvent): void {
    this.contactservice.dataStart = event.pageIndex * event.pageSize;
    this.contactservice.dataLimit = event.pageSize;
    this.contactservice.load();
  }

  getCreator(contact: CNConsultation): string {
    return contact.creator ? contact.creator.lastname + ' ' + contact.creator.firstname : '';
  }

  getCreatedDate(contact: CNConsultation): string {
    return  moment(contact.createddate).format('DD/MM/YYYY');
  }
}
